// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1e5Op","inputWrap":"Table_inputWrap__1TlBk","col":"Table_col__3eNkn","bmiTooltip":"Table_bmiTooltip__3nxks"};